/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1MylibraryStudentsCandidates200,
  GetApiV1MylibraryStudentsCandidates400,
  GetApiV1MylibraryStudentsCandidates401,
  GetApiV1MylibraryStudentsCandidates500,
  GetApiV1MylibraryStudentsCandidatesQueryParams,
  GetApiV1MylibraryStudentsCandidatesQueryResponse,
} from "../../types/myLibraryCandidatosController/GetApiV1MylibraryStudentsCandidates.ts";
import { myLibraryCandidateViewModelSchema } from "../myLibraryCandidateViewModelSchema.ts";

export const getApiV1MylibraryStudentsCandidatesQueryParamsSchema = z.object({
  ClassStudentIds: z.optional(
    z
      .array(z.coerce.number().int())
      .describe(
        "IDs das turmas a filtrar. Lista vazia significa nenhum filtro de turma. Opcional.",
      ),
  ),
  PersonIds: z.optional(
    z
      .array(z.coerce.number().int())
      .describe(
        "IDs das pessoas a filtrar. Lista vazia significa nenhum filtro de pessoa. Opcional.",
      ),
  ),
  HasAnyFilter: z.optional(
    z
      .boolean()
      .describe(
        "Somente leitura. Indica se ao menos um dos dois filtros foi informado — é obrigatório informar pelo menos um.",
      ),
  ),
  culture: z.string().default("pt-BR"),
}) as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1MylibraryStudentsCandidates200Schema = z.array(
  z.lazy(() => myLibraryCandidateViewModelSchema),
) as unknown as ToZod<GetApiV1MylibraryStudentsCandidates200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1MylibraryStudentsCandidates400Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryStudentsCandidates400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1MylibraryStudentsCandidates401Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryStudentsCandidates401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1MylibraryStudentsCandidates500Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryStudentsCandidates500>;

export const getApiV1MylibraryStudentsCandidatesQueryResponseSchema = z.lazy(
  () => getApiV1MylibraryStudentsCandidates200Schema,
) as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesQueryResponse>;
